import { Tooltip } from "@mui/material";
import classNames from "classnames";

import styles from "./style.module.scss";

export interface IStatusRule {
    color: string;
    text: string; // Translated text
    cssBackgroundColor?: string;
    cssIconColor?: string;
}

interface IStatusChip {
    /**
     * Status of the chip displayed.
     */
    status: any;
    /**
     * Rules to knw chich color and text to display.
     */
    statusRules: Record<any, IStatusRule>;
    allowHover?: boolean;
    style?: React.CSSProperties;
    width?: string;
    hideDot?: boolean;
    tooltipText?: string;
    extraText?: string;
    extraElement?: React.ReactNode;
    /**
     * custom label
     */
    label?: string;
}

// Chip as seen on Articles Table or Agreement Table.
const StatusChip = ({
    status,
    statusRules,
    allowHover,
    style,
    width,
    hideDot = false,
    tooltipText,
    extraText,
    extraElement,
    label,
}: IStatusChip) => {
    const chipDisplayed = statusRules[status ?? 0];

    return (
        <Tooltip arrow title={tooltipText ?? ""}>
            <div
                className={classNames("flex items-center justify-center gap-1", {
                    [styles["status-chip"]]: true,
                    [styles["hide-dot"]]: hideDot,
                    [styles["blue"]]: chipDisplayed.color === "blue",
                    [styles["green"]]: chipDisplayed.color === "green",
                    [styles["purple"]]: chipDisplayed.color === "purple",
                    [styles["red"]]: chipDisplayed.color === "red",
                    [styles["yellow"]]: chipDisplayed.color === "yellow",
                    [styles["orange"]]: chipDisplayed.color === "orange",
                    [styles["grey"]]: chipDisplayed.color === "grey",
                    [styles["hover"]]: allowHover,
                })}
                style={{ ...style, width: width }}
            >
                {" "}
                {label || chipDisplayed?.text || ""} {extraText ?? ""}
                {extraElement}
            </div>
        </Tooltip>
    );
};

export default StatusChip;
